import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';

@Injectable({
  providedIn: 'root',
})
export class CanvasService {
  constructor() {}

  async createCanvasFromHTML(element: HTMLElement): Promise<HTMLCanvasElement> {
    const contentWidth = element.scrollWidth;

    const canvas = await html2canvas(element, {
      scale: 3,
      windowWidth: 1600,
      width: contentWidth,
      onclone: (_doc: Document, clonedElement: HTMLElement) => {
        clonedElement.style.width = `${contentWidth}px`;
        clonedElement.style.minWidth = `${contentWidth}px`;
        clonedElement.style.overflow = 'visible';
        let parent = clonedElement.parentElement;
        while (parent) {
          parent.style.overflow = 'visible';
          parent.style.maxWidth = 'none';
          parent.style.width = 'auto';
          parent = parent.parentElement;
        }
      },
    });
    return canvas;
  }
}
 